function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 96.5,
  cy: 88,
  rx: 79.5,
  ry: 75,
  fill: "#B4DE5A"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  width: 88.9172,
  height: 16.5229,
  rx: 8.26143,
  transform: "matrix(0.63969 -0.768633 0.780701 0.624905 74.4305 117.345)",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  width: 49.9083,
  height: 16.511,
  rx: 8.25549,
  transform: "matrix(0.779194 0.626783 -0.641587 0.76705 58.5932 83.681)",
  fill: "white"
});

const SvgCheckMark = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 192 177",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgCheckMark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check_mark.28d55b76.svg";
export { ForwardRef as ReactComponent };